import { render } from "./PlanScale.vue?vue&type=template&id=8b5f6a04&scoped=true"
import script from "./PlanScale.vue?vue&type=script&lang=js"
export * from "./PlanScale.vue?vue&type=script&lang=js"

import "./PlanScale.vue?vue&type=style&index=0&id=8b5f6a04&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b5f6a04"]])

export default __exports__